import React from 'react';
import MainLayout from 'layouts/MainLayout';
import {Outlet} from "react-router-dom";
import {useUserProfileQuery} from "../../apis/authenticationApi";
import { Message } from 'primereact/message';
import HomePageWidget from './HomePageWidget';

const HomePage = () => {
    const {data: userProfile, isFetching} = useUserProfileQuery();

    if(isFetching)
        return (<></>);

    return (<MainLayout>
        {!userProfile?.company?.id ?
            <Message style={{width:"100%"}} severity="warn" text="The account is valid, however there is no company associated with this user." /> 
        :
            <HomePageWidget/>
        }
                    
        <Outlet />
    </MainLayout>);
}

export default HomePage;
